var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "h2 pt-2 mb-2" }, [
        _vm._v("\n            " + _vm._s(_vm.title) + "\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row swiper-1row d-lg-none mb-1 mt-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "div",
            { staticClass: "ob1-carrousel marchand-parcours-swiper-container" },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(
                  _vm.zoneMarchandParcours.zoneMarchandParcoursItem,
                  function (zoneMarchandParcoursItem, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "swiper-slide" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card ob1-push ob1-push-carrefour ob1-push-shadow-right ob1-push-md-shadow-left",
                          },
                          [
                            _c("div", { staticClass: "card-header" }, [
                              _c("img", {
                                staticClass: "w-100 card-img-top",
                                attrs: {
                                  src: zoneMarchandParcoursItem.image.src,
                                  alt: zoneMarchandParcoursItem.image.alt,
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "h3",
                                {
                                  staticClass: "card-title",
                                  attrs: { "data-clamp": "2" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(zoneMarchandParcoursItem.title) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("p", { staticClass: "card-text" }, [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(zoneMarchandParcoursItem.text) +
                                    "\n                                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "py-0 card-btn" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "btn btn-secondary btn-custom-height",
                                    staticStyle: { height: "72px" },
                                    attrs: {
                                      href: zoneMarchandParcoursItem.urlButton,
                                      "data-oevent-category":
                                        zoneMarchandParcoursItem.tms.tagZone +
                                        (index + 1),
                                      "data-oevent-action": _vm.tagName(
                                        zoneMarchandParcoursItem.labelButton
                                      ),
                                      "data-oevent-label":
                                        zoneMarchandParcoursItem.urlButton,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        zoneMarchandParcoursItem.labelButton
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }
                ),
                0
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-none d-lg-block mb-1 mt-2" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(
              _vm.zoneMarchandParcours.zoneMarchandParcoursItem,
              function (zoneMarchandParcoursItem, index) {
                return [
                  _c("div", { key: index, staticClass: "col-12 col-md-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "card ob1-push ob1-push-carrefour ob1-push-shadow-right ob1-push-md-shadow-left",
                      },
                      [
                        _c("div", { staticClass: "card-header" }, [
                          _c("img", {
                            staticClass: "w-100 card-img-top",
                            attrs: {
                              src: zoneMarchandParcoursItem.image.src,
                              alt: zoneMarchandParcoursItem.image.alt,
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-body" }, [
                          _c(
                            "h3",
                            {
                              staticClass: "card-title",
                              attrs: { "data-clamp": "2" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(zoneMarchandParcoursItem.title) +
                                  "\n                                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(zoneMarchandParcoursItem.text) +
                                "\n                                "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "py-0 card-btn" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-secondary btn-custom-height",
                                staticStyle: { height: "72px" },
                                attrs: {
                                  href: zoneMarchandParcoursItem.urlButton,
                                  "data-oevent-category":
                                    zoneMarchandParcoursItem.tms.tagZone +
                                    (index + 1),
                                  "data-oevent-action": _vm.tagName(
                                    zoneMarchandParcoursItem.labelButton
                                  ),
                                  "data-oevent-label":
                                    zoneMarchandParcoursItem.urlButton,
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(zoneMarchandParcoursItem.labelButton)
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              }
            ),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }